
import { supabase } from "@/integrations/supabase/client";

// Helper function to get app URL that works in both client and server environments
export const getAppUrl = (): string => {
  return typeof window !== 'undefined' 
    ? window.location.origin 
    : 'https://labswapp.vercel.app'; // Updated official URL
};

// Helper function to generate the swap request URL
export const getSwapRequestUrl = (swapRequestId?: string): string => {
  const appUrl = getAppUrl();
  if (swapRequestId) {
    return `${appUrl}/swap-request/${swapRequestId}`;
  }
  return `${appUrl}/my-reagents?tab=swap-requests`;
};

// Helper function to send an email
export const sendEmail = async (
  to: string,
  subject: string,
  html: string
): Promise<boolean> => {
  try {
    console.log(`Sending email to ${to} with subject: ${subject}`);
    
    const { data, error } = await supabase.functions.invoke("send-email", {
      body: { to, subject, html }
    });
    
    if (error) {
      console.error("Error sending email:", error);
      return false;
    }
    
    console.log("Email sent successfully:", data);
    return true;
  } catch (error) {
    console.error("Exception in sendEmail:", error);
    return false;
  }
};
